import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-diagnosis-by-hcc-dw",
  templateUrl: "./diagnosis-by-hcc-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosisByHccDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.DIAGNOSIS_BY_HCC_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
